export const CASHIER_BILLING_PATH = `/cashier/billing`;
export const CASHIER_BILLING_CONFIRMATIONS_PATH = `${CASHIER_BILLING_PATH}/%d/confirmations`;
export const CASHIER_BILLING_CONFIRMATIONS_INVOICED_PATH = `${CASHIER_BILLING_PATH}/%d/invoices`;
export const CASHIER_BILLING_CONFIRMATIONS_INVOICED_PRINT_PATH = `${CASHIER_BILLING_PATH}/%d/invoices/print`;
export const CASHIER_BILLING_INVOICE_PREVIEW_PATH = `${CASHIER_BILLING_PATH}/%d/preview-invoice`;
export const CASHIER_BILLING_CONFIRM_INVOICE_PATH = `${CASHIER_BILLING_PATH}/%d/confirm-invoice`;
export const CASHIER_BILLING_TRANSACTIONS_PATH = `${CASHIER_BILLING_PATH}/%d/transactions/%s/%d`;
